import React from 'react';
import { graphql } from 'react-apollo';
import ProductionGrid from '../../../components/Production/ProductionGrid';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import SEARCH_ELEMENTS_QUERY from '../../../graphql/SearchElements';
import SearchBar from '../../../components/SearchBar/index';

class SearchElements extends React.PureComponent {
  onSearch(terms) {
    if (!{}.hasOwnProperty.call(terms, 'advanced') || terms.advanced === false) {
      this.props.history.push(`/search/${terms.query}`);
    } else {
      let path = '/search/elements';
      if (terms.kind === 'productions') {
        path = '/search/productions';
      }
      this.props.history.push({
        pathname: path,
        state: terms,
      });
    }
  }

  render() {
    return (
      <div>
        <Banner />
        <div className="recent-properties">
          <div className="container">
            <div className="main-title">
              <h1>Resultados búsqueda</h1>
              <div className="border">
                <div className="border-inner" />
              </div>

              <SearchBar onSearch={terms => this.onSearch(terms)} />
            </div>
            {this.props.productions ? (
              <div>
                <h3>Producciones</h3>
                <i>({this.props.productions.length} resultados)</i>
                <ProductionGrid
                  limit
                  limitTo={3}
                  showMore
                  productions={this.props.productions}
                />
              </div>
            ) : (
              <div />
            )}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withSearchResults = graphql(SEARCH_ELEMENTS_QUERY, {
  options: ({ location }) => ({
    variables: location.state,
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    productions: data.searchElements ? data.searchElements.productions : [],
  }),
});
export default withSearchResults(SearchElements);



// WEBPACK FOOTER //
// ./src/containers/Search/Elements/index.js